export default Object.freeze({
  Monday: 'Meat is Murder Monday',
  Tuesday: 'High Tide Tuesday',
  Wednesday: 'Witchcraft Wednesday',
  Thursday: 'Thursday',
  Friday: 'Frostbite Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Halloween: '🎃 Happy Halloween!',
});



// WEBPACK FOOTER //
// ./src/data/days.js